const CicleCheckIcon = () => {
  return (
    <svg
      width="13"
      height="26"
      viewBox="0 0 13 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Ellipse 8"
        d="M0 25C6.62742 25 12 19.6274 12 13C12 6.37258 6.62742 1 0 1"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export default CicleCheckIcon;
